import photo2 from "/public/images/events/houlgate/stage-houlgate-25/photo2.webp";

export const stageHoulgate25Images = [
  {
    src: photo2,
    alt: "Stage Houlgate 2025 - Photo 2",
    format: "3:2" as const,
  },
];
